export default __webpack_public_path__ + "static/media/3_chr_img.bc63ee33.png";